<app-error-page [errorMsg]="errorMsg" *ngIf="containsError"></app-error-page>

<div *ngIf="!containsError" class="query-transaction-container">

    <div class="pageHeader" id="queryTransactionsHeader">Submit Transaction Query</div>
    <div class="warningMessage" *ngIf="warningMessage">
      <li>{{warningMessage}}</li>
    </div>

    <div class="errorMessage" *ngIf="errorMessage?.length">
      You must correct the following error(s) before proceeding:
      <li *ngFor="let message of errorMessage">{{message}}</li>
    </div>

    <form [formGroup]="queryTransactionForm" (ngSubmit)= "queryTransationList()" >
      <div class="query-transaction">
        <div class="ui-g">
          <div class="ui-g-3 lableright glypha-font u-fw-bold"><span class="u-fw-normal">
            Enter a</span> Loan Number:
          </div>
          <div class="ui-g-3"><input type="text" id="loanNumber" fmTextInput formControlName="loanNumber"  [maxlength]="10"></div>

          <div class="ui-g-3 lableright glypha-font u-fw-bold"><span class="u-fw-normal">Or</span> Servicer Number:</div>


          <div class="ui-g-3"  *ngIf="!isExternal">
            <input type="text" id="servicerNumber" fmTextInput formControlName="servicerNumber"  [maxlength]="9">
          </div>

          <div class="ui-g-3" *ngIf="isExternal">

            <fm-select
              [options]="serNumber"
              ariaLabelledBy="default"
              formControlName="servicerNumber"
            ></fm-select>
          </div>
        </div>
        <div class="search-criteria-text">
          <span class="selecton-text">or any combination of the following attributes:</span>
        </div>

        <div class="ui-g">
          <div class="ui-g-3 lableright glypha-font u-fw-bold">Transaction Status:</div>
          <div class="ui-g-3">
            <div class="select-style">
              <fm-select [options]="transactionStatus" ariaLabelledBy="default"
                formControlName="transactionStatus"></fm-select>
            </div>
          </div>
          <div class="ui-g-3 lableright glypha-font u-fw-bold"> Product Type: </div>
          <div class="ui-g-3">
            <div class="select-style">
              <fm-select [options]="productType" ariaLabelledBy="default"
                formControlName="productType"></fm-select>
            </div>
          </div>
        </div>

        <div class="ui-g">
          <div class="ui-g-3 lableright glypha-font u-fw-bold">Action Code:</div>
          <div class="ui-g-3">

            <div class="select-style">
              <fm-select [options]="actionCode" ariaLabelledBy="default"
                formControlName="actionCode"></fm-select>
            </div>
          </div>

          <div class="ui-g-3 lableright glypha-font u-fw-bold">Transaction Designator:</div>
          <div class="ui-g-3">
            <div class="select-style">
              <fm-select [options]="tranDesignator" ariaLabelledBy="default"
                formControlName="tranDesignator"></fm-select>
            </div>
          </div>
        </div>

        <div class="search-criteria-text u-fw-bold">
          <span class="selecton-text bold-font glypha-font">Effective Date Range:</span>
        </div>

        <div class="ui-g">
          <div class="ui-g-3 lableright glypha-font"> From:</div>
          <div class="ui-g-3">
            <fm-calendar placeholder="MM/DD/YYYY" formControlName="effectiveDateFrom"
            [monthNavigator]="true" [yearNavigator]="true" [yearRange]="('1990:2050')" [showClear]="true" ></fm-calendar>
          </div>
          <div class="ui-g-3 lableright glypha-font"> To:</div>
          <div class="ui-g-3">
            <fm-calendar placeholder="MM/DD/YYYY" formControlName="effectiveDateTo"
            [monthNavigator]="true" [yearNavigator]="true" [yearRange]="('1990:2050')" [showClear]="true" ></fm-calendar>
          </div>
        </div>

        <div class="search-criteria-text">
          <span class="selecton-text bold-font glypha-font u-fw-bold">Creation Date Range:</span>
        </div>

        <div class="ui-g">
          <div class="ui-g-3 lableright glypha-font"> From:</div>
          <div class="ui-g-3">
            <fm-calendar placeholder="MM/DD/YYYY" formControlName="postingDateFrom"
            [monthNavigator]="true" [yearNavigator]="true" [yearRange]="('1990:2050')"  [showClear]="true" ></fm-calendar>
          </div>
          <div class="ui-g-3 lableright glypha-font"> To:</div>
          <div class="ui-g-3">
            <fm-calendar placeholder="MM/DD/YYYY" formControlName="postingDateTo"
            [monthNavigator]="true" [yearNavigator]="true" [yearRange]="('1990:2050')" [showClear]="true" ></fm-calendar>
          </div>
        </div>


        <div class="ui-g">
          <div class="ui-g-3 lableright glypha-font u-fw-bold"> Sort By:</div>
          <div class="ui-g-3">
            <fm-select [options]="sortBy" placeholder="Choose" ariaLabelledBy="default"
              formControlName="sortBy"></fm-select>
          </div>
          <div class="ui-g-3"></div>
          <div class="ui-g-3"></div>
        </div>

        <div class="ui-g">
          <div class="ui-g-6">
            <button fmButton type="submit" id="queryTransactionsSubmit" [primary]="true" [small]="true" label="Submit"
              class="buttonmargin"></button>
            <button fmButton type="button" id="queryTransactionsClear" label="Clear" [small]="true" (click)="onClear()"
              class="buttonmargin"></button>
            <button fmButton type="button" id="queryTransactionsCancel" label="Cancel" [small]="true"
              routerLink="/reverseMortgage" class="buttonmargin"></button>
          </div>
          <div class="ui-g-6"></div>
        </div>
      </div>

    </form>
  </div>

